import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from "@mui/x-data-grid";
import {useEffect, useState} from "react";
import {
    Box,
    Button,
    Card,
    CardHeader,
    Container,
    Divider,
    Grid,
    Link,
    MenuItem,
    Modal,
    Typography
} from "@mui/material";
import axios from "axios";
import { useAuthState } from 'react-firebase-hooks/auth';
import {TableMoreMenu} from "../../components/table";
import Page from "../../components/Page";
import LoadingBackdrop from "../../components/LoadingBackdrop";
import Iconify from "../../components/Iconify";
import useSettings from "../../hooks/useSettings";
import {BASE_HOST, getAccountAPIHeader} from "../../utils/urlConst";
import AdTypeToolTip from "./components/AdTypeToolTip";
import { auth } from '../../firebase';

const modalStyle = {
    position: 'absolute',
    top: '25%',
    left: '50%',
    transform: 'translate(-50%, -25%)',
    // width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export default function Offers() {
    const {themeStretch} = useSettings();
    const [loadingLists, setLoadingLists] = useState(true);
    const [openMenu, setOpenMenuActions] = useState(null);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [user] = useAuthState(auth);

    const handleCloseMenu = () => {
        setOpenMenuActions(null);
    };

    function generateActionMenuForRow(row) {
        const buttons = [];


        buttons.push(
            <MenuItem
                onClick={() => {
                    window.location=`/dashboard/offer?id=${row.id}`;
                }}
            >
                <Iconify icon={'eva:eye-fill'}/>
                <p>View</p>
            </MenuItem>
        )

        if(row.fulfillmentMethod !== "off"){
            buttons.push(
                <MenuItem
                    onClick={() => {
                    }}
                >
                    <Iconify icon={'eva:pause-circle-fill'}/>
                    <p>Disable</p>
                </MenuItem>
            )
        }

        return <>
            {buttons}
        </>
    }

    const [lists, setLists] = useState([]);

      useEffect(() => {
            user.getIdToken().then((idToken) => {
                axios.get(`${BASE_HOST}/api/basic/offers`, getAccountAPIHeader(idToken))
                  .then(res => {
                      console.log("Offers Loaded");
                      console.log(res);
                      setLists(res.data)
                      setLoadingLists(false);
                  })
            })
      }, [])


    const columns = [
        {field: 'hasOfferId', headerName: "Offer Id",  maxWidth: 75, hide: true},
        {field: 'name', headerName: "Offer Name", flex: 1, minWidth: 120, renderCell: (params) =><Link href={`/dashboard/offer?id=${params.row.id}`} target="_blank">{params.row.name}</Link>},
        {field: 'advertiser', headerName: "Advertiser", flex: 1, minWidth: 120},
        {field: 'type', headerName: "Offer Type"},
        {field: 'status', headerName: "status"},
        {field: 'fulfillmentMethod', headerName: "Fulfillment Type", minWidth: 125},
        {field: 'ads', headerName: "# Of Ads", minWidth: 100},
        {field: 'biasPercent', headerName: "% Serv", minWidth: 100, valueGetter: (params) => `${(params.row.biasPercent*100.0).toFixed(2)}%`},
        {
            field: "actions",
            headerName: "Actions",
            width: 75,
            renderCell: (params) => <TableMoreMenu
                    open={(openMenu != null && openMenu.id === params.row.id) ? openMenu.bind : null}
                    onOpen={(event) => setOpenMenuActions({id: params.row.id, bind: event.currentTarget})}
                    onClose={handleCloseMenu}
                    actions={generateActionMenuForRow(params.row)}
                />
        }
    ];


    let hideStates = window.localStorage.getItem("OffersHideState")
    if(hideStates){
        hideStates = JSON.parse(hideStates);
        console.log(hideStates);
        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of Object.entries(hideStates)) {
          columns.forEach(v=> {if(v.field===key){v.hide=!value} })
        }

        console.log(columns);
    }

    const [actionMenu, setActionMenu] = useState({mixAds: false, previewAds: false, states: false, loading:false});
    function setStateOnSelected(state) {
        const promisesToAwait = [];
        user.getIdToken().then((idToken) => {
            selectedColumns.forEach((o) => {
                promisesToAwait.push(
                  axios.put(`${BASE_HOST}/api/basic/offers`, { id: o, fulfillmentMethod: state }, getAccountAPIHeader(idToken))
                )
            });
            Promise.all(promisesToAwait).then(() => {
            setActionMenu({mixAds: false, previewAds: false, states: false, loading:false});
            window.location.reload();
        });
        })
    }
    function CustomToolbar() {
        let customToolBar = <GridToolbarContainer>
            <GridToolbarColumnsButton/>
            <GridToolbarFilterButton/>
            <GridToolbarDensitySelector/>
            <GridToolbarExport/>
        </GridToolbarContainer>;
        if (selectedColumns.length > 0) {
            customToolBar = <GridToolbarContainer>
                <GridToolbarColumnsButton/>
                <GridToolbarFilterButton/>
                <GridToolbarDensitySelector/>
                <GridToolbarExport/>
                <Button variant={"contained"} id="set-state-button"
                        onClick={() => setActionMenu({...actionMenu, states: true})}>
                    Set Fulfillment
                </Button>



                <Modal
                    open={actionMenu.states}
                    onClose={() => setActionMenu({...actionMenu, states: false})}
                    style={{"overflowY": "scroll"}}
                >
                    <Box sx={{...modalStyle}}>
                        <Typography>
                            Set Ad Status For Selected Ads. <AdTypeToolTip/>
                        </Typography>
                        <Button onClick={() => {
                            setActionMenu({...actionMenu, states: false, loading: true});
                            setStateOnSelected('open');
                        }}>> Set Fulfillment Open</Button>
                        <br/>
                        <Button onClick={() => {
                            setActionMenu({...actionMenu, states: false, loading: true});
                            setStateOnSelected('off');
                        }}>> Set Fulfillment To OFF</Button>
                        <br/>
                        <Button onClick={() => {
                            setActionMenu({...actionMenu, states: false, loading: true});
                            setStateOnSelected('fixed');
                        }}>> Set Fulfillment To FIXED</Button>
                        <br/>
                    </Box>
                </Modal>

            </GridToolbarContainer>
        }
        return customToolBar
    }
    
    return <Page title="General: Offers">
        {loadingLists ? <LoadingBackdrop/> :
            <Container maxWidth={themeStretch ? false : 'xl'}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={12}>

                        <Card>
                            <CardHeader title={[
                                <Typography key={"h1K"} variant="title">Offers</Typography>,

                            ]} sx={{mb: 3}}/>

                            <div style={{height: Math.max(parseInt(window.innerHeight * .65, 10), 400), width: '100%'}}>
                                <DataGrid
                                    rows={lists}
                                    columns={columns}
                                    pageSize={50}
                                    rowsPerPageOptions={[50]}
                                    checkboxSelection
                                    disableSelectionOnClick
                                    onSelectionModelChange={(v) => setSelectedColumns(v)}
                                    components={{ Toolbar: CustomToolbar }}
                                    onColumnVisibilityModelChange={(newModel) => {
                                        console.log(newModel);
                                         window.localStorage.setItem("OffersHideState", JSON.stringify(newModel));
                                    }}
                                />
                            </div>
                            <Divider/>
                        </Card>
                    </Grid>
                </Grid>
            </Container>
        }

         {/* <ErrorModal /> */}
    </Page>;
}